module.exports = __webpack_public_path__ + "img/flower-top-big.91455c17.png";